import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';

import BenchmarkingComponent from '../components/benchmarking/BenchmarkingComponent';

//tooltip questionmark
import GraphTooltip from '../components/reporting/GraphTooltip';

const Benchmarking = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className='benchmarking-title-wrapper'>
        <h1>{t('benchmarking.name')}</h1>
        <GraphTooltip
          id='AvgPigsPerDelivery'
          question='true'
          message={`${t('benchmarking.mainInfoOne') + t('benchmarking.mainInfoTwo') + t('benchmarking.mainInfoThree')}`}
        />
      </div>

      <div className='mt-4'>
        <BenchmarkingComponent />
      </div>
    </Fragment>
  );
};

export default Benchmarking;
